

export function getTranslation(key: string) {
  const keys = key?.includes('.') ? key.split('.') : [];
  const translationObj = (globalThis as any).translationObj;
  const value = (translationObj && keys[0] && translationObj[keys[0]]) ? translationObj[keys[0]] : null;
  if (value !== undefined && value !== null) {
    return keys[1] ? value[keys[1]] ?? value : value;
  }
  return key;
}

export function rephraseTranslation(key: string, values: any): string | null {
  let msg: string;
  if (key) {
    msg = getTranslation(key);
    if (msg && values && values.length) {
      values.forEach((res: any, index: number) => msg = msg.replace('${' + index + '}', res));
    }
    return msg;
  }
  return null;
}